export default __webpack_public_path__ + "27152cd1fa94915179ea9dd966dfc10e.webp";